<div class="button-container">

  <div class="button-item">
    <button class="btn p-0 mt-1 border-0 d-flex" (click)="open(content)">
         <i class="fi fi-rr-add"></i>
        <span *ngIf="categories.length == 0" class="mx-1"> {{ "CATEGORY.ADD_CATEGORY" | translate }} </span>
    </button>
  </div>

  <div class="button-item" *ngIf="load" >
    <button class="btn btn-secondary skeleton"> {{"LOADING" | translate }}... </button>
  </div>

  <div class="button-item" *ngFor="let category of categories">
    <div *ngIf="!load">
      <button class="btn-edit" (click)="open(content, category)">
        <i class="fi fi-rr-pencil"></i>
      </button>
      <div class="card bg-none border">{{ category?.titles?.[systemLang] }}</div>
    </div>
  </div>

</div>

<ng-template #content let-modal>
  <div class="modal-body">
    <div class="custom-dropdown-menu">
      <div [formGroup]="form" (ngSubmit)="createOrUpdateCategory()">
          
          <app-language-selector
            [appId]="id"
            [showName]="false"
            [style]="false"
            (languageChanged)="addLanguageField()"
          ></app-language-selector>

          <div formArrayName="titles" class="mt-2">
            <div *ngFor="let item of titles.controls; let i = index" [formGroupName]="i">
              <div *ngIf="item.get('language')?.value === selectedLanguage">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="value"
                    placeholder="{{ 'CATEGORY.TITLE_CATEGORY' | translate }}"
                  />
              </div>
            </div>
          </div>
          
          <div class="mt-2">
            <button type="button" class="btn btn-primary" (click)="createOrUpdateCategory()" [ngClass]="{'disabled':  isCategoryLoad}">
              <span class="d-flex">
                <app-spinner *ngIf="isCategoryLoad" [sm]="true"></app-spinner>
                <span *ngIf="isEdit" class="mx-1">{{'EDIT' | translate}}</span>
                <span *ngIf="!isEdit" class="mx-1">{{'ADD' | translate}}</span>
              </span>
              
            </button>

            <button type="button" (click)="deleteCategory(form.value.id)" *ngIf="isEdit" class="btn btn-danger mx-1" [ngClass]="{'disabled':  deleteLoad}">
              <i *ngIf="!deleteLoad" class="fi fi-rr-trash"></i>
              <app-spinner *ngIf="deleteLoad" [sm]="true"></app-spinner>
            </button>
          </div>
        
      </div>
    </div>
  </div>
</ng-template>

<app-error *ngIf="error" [title]="''"></app-error>
  
  